import kinetikApi from './kinetikAPI';

export default {
  getNotifications: (params) =>
    kinetikApi
      .get('/notifications/ORGANIZATION', {
        ...params,
        serviceName: 'notification',
      })
      .then((res) => res.data),
  markNotificationAsRead: (notificationUuid) =>
    kinetikApi
      .patch(`/notifications/n/${notificationUuid}/mark-as-read`, undefined, {
        serviceName: 'notification',
      })
      .then((res) => res.data),
  markAllNotificationAsRead: (orgResourceId, params) =>
    kinetikApi
      .patch('/notifications/n/ALL/mark-as-read', null, {
        ...params,
        serviceName: 'notification',
      })
      .then((res) => res.data),
  getNotificationStubs: (orgResourceId, options) =>
    kinetikApi
      .get(`/notification-stubs/o/${orgResourceId}`, {
        ...options,
        serviceName: 'notification',
      })
      .then((res) => res.data),
};
